'use client';

import { useSyncedLocalStorage, writeSyncedLocalStorage } from '@/lib/syncedLocalStorage';

const DISABLED_CAPABILITIES_KEY = 'photonium_disabled_capabilities';
const DISABLED_CAPABILITIES_CHANGED_EVENT = 'disabledCapabilitiesChanged';

export interface DisabledCapabilities {
  tools: string[];
  skills: string[];
  subagents: string[];
}

const EMPTY: DisabledCapabilities = { tools: [], skills: [], subagents: [] };

function readFromStorage(): DisabledCapabilities {
  if (typeof window === 'undefined') return EMPTY;
  try {
    const raw = localStorage.getItem(DISABLED_CAPABILITIES_KEY);
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw);
    return {
      tools: Array.isArray(parsed.tools) ? parsed.tools : [],
      skills: Array.isArray(parsed.skills) ? parsed.skills : [],
      subagents: Array.isArray(parsed.subagents) ? parsed.subagents : [],
    };
  } catch {
    return EMPTY;
  }
}

export function useDisabledCapabilities() {
  const disabled = useSyncedLocalStorage(
    DISABLED_CAPABILITIES_KEY,
    DISABLED_CAPABILITIES_CHANGED_EVENT,
    readFromStorage,
  );

  function setDisabled(d: DisabledCapabilities): void {
    writeSyncedLocalStorage(
      DISABLED_CAPABILITIES_KEY,
      DISABLED_CAPABILITIES_CHANGED_EVENT,
      JSON.stringify(d),
    );
  }

  return { disabled, setDisabled };
}

export function getDisabledCapabilities(): DisabledCapabilities {
  return readFromStorage();
}

export function getDisabledCount(d: DisabledCapabilities): number {
  return d.tools.length + d.skills.length + d.subagents.length;
}
